import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { SaleDash } from '../models/sale-dash';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  getSaleDash(cnpj: string, fromDate: string, toDate: string, teams?: any[], sellers?: any[]): Observable<SaleDash> {
    if (cnpj === '') {
      return of();
    }

    let body = {};
    body = {
      dataDe: fromDate.substr(0, 10).concat('T00:00:00-03:00'),
      dataAte: toDate.substr(0, 10).concat('T23:59:59-03:00'),
      equipes: teams,
      vendedores: sellers,
    };

    return this.http
      .post<SaleDash>(`${environment.vendas}/vendadash/${cnpj}`, body, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }
}
